export const LOADING_START = "LOADING_START";
export const LOADING_FAILED = "LOADING_FAILED";
export const LOADING_STOP = "LOADING_STOP";
export const RESET_GENERAL_STORE = "RESET_GENERAL_STORE";
